module.exports = __webpack_public_path__ + "img/shoes.be5030ca.webp";